/* Native size chart — highlights the selected size row; opens/closes the popup (dialog) version. */
(function () {
  if (window.__sizeChartInit) return;
  window.__sizeChartInit = true;

  // "Small", "X-Large", "XX-Large", "2-XL" etc. all compare as s / xl / 2xl.
  function normSize(v) {
    var s = String(v || '').trim().toLowerCase().replace(/\s+/g, '');
    var named = { small: 's', medium: 'm', large: 'l', 'x-large': 'xl', xlarge: 'xl', 'xx-large': '2xl', xxlarge: '2xl', 'xxx-large': '3xl', xxxlarge: '3xl' };
    if (named[s]) return named[s];
    var m = s.match(/^(\d)x-?large$/);
    if (m) return m[1] + 'xl';
    return s.replace(/-/g, '');
  }

  function currentSize() {
    var input =
      document.querySelector('fieldset[data-size] input:checked') ||
      document.querySelector('input[type="radio"][name^="Size"]:checked');
    return input ? normSize(input.value) : '';
  }

  // The size radio (variant picker) whose value matches a chart row, if any.
  function sizeInputFor(key) {
    var inputs = document.querySelectorAll('fieldset[data-size] input[type="radio"]');
    if (!inputs.length) inputs = document.querySelectorAll('input[type="radio"][name^="Size"]');
    for (var i = 0; i < inputs.length; i++) {
      if (normSize(inputs[i].value) === normSize(key)) return inputs[i];
    }
    return null;
  }

  function highlightSize() {
    var size = currentSize();
    document.querySelectorAll('[data-sc-table] tr[data-sc-size]').forEach(function (row) {
      var key = row.getAttribute('data-sc-size');
      row.classList.toggle('is-selected', !!size && normSize(key) === size);
      // Rows that match a size option can be clicked to select that size.
      var input = sizeInputFor(key);
      var selectable = !!input && !input.disabled;
      row.classList.toggle('is-selectable', selectable);
      if (selectable) {
        row.setAttribute('tabindex', '0');
        row.setAttribute('title', 'Select size ' + input.value);
      } else {
        row.removeAttribute('tabindex');
        row.removeAttribute('title');
      }
    });
  }

  function selectFromRow(row) {
    var input = sizeInputFor(row.getAttribute('data-sc-size'));
    if (!input || input.disabled) return;
    if (!input.checked) input.click(); // lets the theme update variant, price, etc.
    highlightSize();
    var dlg = row.closest('dialog');
    if (dlg && dlg.open) setTimeout(function () { dlg.close(); }, 250);
  }

  function openModal(id) {
    var dlg = document.getElementById(id);
    if (!dlg || typeof dlg.showModal !== 'function') return false;
    highlightSize();
    if (!dlg.open) dlg.showModal();
    document.documentElement.classList.add('sc-modal-open');
    if (!dlg.__scCloseBound) {
      dlg.__scCloseBound = true;
      // Release the page scroll lock however the dialog gets closed (button,
      // backdrop, Esc). Watching the "open" attribute is synchronous and more
      // reliable than the async "close" event.
      new MutationObserver(function () {
        if (!dlg.open) document.documentElement.classList.remove('sc-modal-open');
      }).observe(dlg, { attributes: true, attributeFilter: ['open'] });
    }
    return true;
  }

  document.addEventListener('click', function (e) {
    var row = e.target.closest && e.target.closest('[data-sc-table] tr.is-selectable');
    if (row) {
      selectFromRow(row);
      return;
    }
    var opener = e.target.closest && e.target.closest('[data-sc-popup-open]');
    if (opener) {
      if (openModal(opener.getAttribute('data-sc-popup-open'))) e.preventDefault();
      return;
    }
    if (e.target.closest && e.target.closest('[data-sc-popup-close]')) {
      var d = e.target.closest('dialog');
      if (d) d.close();
      return;
    }
    // Click on the dark backdrop (outside the dialog box) closes it.
    if (e.target.tagName === 'DIALOG' && e.target.classList.contains('sc-modal')) {
      var r = e.target.getBoundingClientRect();
      var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!inside) e.target.close();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var row = e.target.closest && e.target.closest('[data-sc-table] tr.is-selectable');
    if (!row) return;
    e.preventDefault();
    selectFromRow(row);
  });

  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches && e.target.matches('input[type="radio"]')) {
      highlightSize();
    }
  });

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function () { setTimeout(highlightSize, 0); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', highlightSize);
  } else {
    highlightSize();
  }
  document.addEventListener('shopify:section:load', highlightSize);
})();

/* "Size Chart" link: the CSS glow runs slowly and endlessly until the visitor
   clicks the link on this page. It comes back after a reload or on the next
   product page (nothing is remembered). Absolute Support + Mojo. */
(function () {
  if (window.__scRepulse) return;
  window.__scRepulse = true;
  var clicked = false;
  function markAll() {
    document.querySelectorAll('a.custom-size__guide[data-sc-popup-open]').forEach(function (el) { el.classList.add('sc-seen'); });
  }
  document.addEventListener('click', function (e) {
    if (!(e.target && e.target.closest && e.target.closest('a.custom-size__guide[data-sc-popup-open]'))) return;
    clicked = true;
    markAll();
  });
  // The theme can re-render the size picker on variant change; keep it calm after a click.
  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (clicked && document.querySelector('a.custom-size__guide[data-sc-popup-open]:not(.sc-seen)')) markAll();
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
